export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_17.8640c950.jpg";